import React from "react";

const PlayIcon = () => {
  return (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73 36.5C73 46.1804 69.1545 55.4643 62.3094 62.3094C55.4643 69.1545 46.1804 73 36.5 73C26.8196 73 17.5357 69.1545 10.6906 62.3094C3.84553 55.4643 0 46.1804 0 36.5C0 26.8196 3.84553 17.5357 10.6906 10.6906C17.5357 3.84553 26.8196 0 36.5 0C46.1804 0 55.4643 3.84553 62.3094 10.6906C69.1545 17.5357 73 26.8196 73 36.5ZM30.9794 23.2368C30.6383 22.9939 30.2369 22.8497 29.8192 22.8197C29.4016 22.7898 28.9837 22.8754 28.6115 23.0672C28.2392 23.259 27.927 23.5495 27.7089 23.907C27.4908 24.2644 27.3753 24.675 27.375 25.0938V47.9062C27.3753 48.325 27.4908 48.7356 27.7089 49.093C27.927 49.4505 28.2392 49.741 28.6115 49.9328C28.9837 50.1246 29.4016 50.2102 29.8192 50.1803C30.2369 50.1503 30.6383 50.0061 30.9794 49.7632L46.9481 38.3569C47.2438 38.1459 47.4849 37.8673 47.6512 37.5443C47.8175 37.2213 47.9043 36.8633 47.9043 36.5C47.9043 36.1367 47.8175 35.7787 47.6512 35.4557C47.4849 35.1327 47.2438 34.8541 46.9481 34.6431L30.9794 23.2368Z"
        fill="#FFEBEB"
      />
    </svg>
  );
};

export default PlayIcon;
